import { campaignData } from './campaignData';
import type { NavigatorApi } from './types';

/**
 * Single point where the runner picks its backend. Inside the portal there is
 * one implementation: `campaignData`, which persists the whole `WorkshopState`
 * blob onto the SE's `CampaignEnrollment.metadata.workshop` row. Components
 * import `api` and never a concrete implementation.
 */
export const api: NavigatorApi = campaignData;

export type { NavigatorApi };
export {
  setRunnerData,
  getRunnerData,
  resolveStakeholders,
  resolveReportSections,
  resolveReportFigures,
  resolveCapabilities,
  resolveContentBlocks,
  resolveAssets,
  resolvePhases,
  resolvePrompts,
} from './campaignData';
export type {
  RunnerDataContext,
  RunnerReportSection,
  RunnerReportFigure,
  RunnerStepContent,
  RunnerFileRef,
  RunnerCapability,
  RunnerContentBlock,
  RunnerAsset,
  RunnerPhase,
  RunnerPrompt,
} from './campaignData';
